import { Component } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { filter } from "rxjs/operators/filter";
import { environment as ENV } from "./../environments/environment";
import { FeatureFlagService } from './shared/services';
declare var gtag: any;
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  showSpin: boolean;
  constructor(private router: Router, private featureFlag: FeatureFlagService) {
    const navEndEvents = router.events.pipe(
      filter((event) => event instanceof NavigationEnd)
    );
    navEndEvents.subscribe((event: NavigationEnd) => {
      const GOOGLE_ID =
        ENV.envName === "pilot"
          ? ENV.google_analytics.GOOGLE_ID_PILOT
          : ENV.google_analytics.GOOGLE_ID_QA;
      gtag("config", GOOGLE_ID, { page_path: event.urlAfterRedirects });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts